const therigyEndpoint = `${window.location.protocol}//${window.location.host}`;
const { port } = window.location;

function getWalkmeUrl(host) {
    if (host.startsWith('staging')) {
        return 'https://cdn.walkme.com/users/f8febc159f7d423e8b2cca9199b48a9d/test/walkme_f8febc159f7d423e8b2cca9199b48a9d_https.js';
    }
    if (!host.match(/stm\.local/) && !host.startsWith('qa')) {
        return 'https://cdn.walkme.com/users/f8febc159f7d423e8b2cca9199b48a9d/walkme_f8febc159f7d423e8b2cca9199b48a9d_https.js';
    }
}

const env = Object.freeze({
    therigyEndpoint,
    catchPhrase: 'Therigy | Improving therapy, enhancing lives',
    cdnURL: 'https://cdn.therigy.com',

    // STM Configuration
    isProd: process.env.NODE_ENV === 'production',
    privacyWebsite: 'https://cps.com/consumer-privacy-notice',
    supportEmail: 'therigysupport@cps.com',
    supportPhoneNumber: '407.992.8750 x3',
    supportWebsite: 'https://cps.com/technical-support',
    therapyIds: {
        general: '6582172ed711c550075d9d1c6c4ba6',
    },

    // AMS Configuration
    amsEndpoint: therigyEndpoint,
    amsPort: port,
    amsSocketEndpoint: therigyEndpoint,
    amsSocketPath: '/ams/socket/',
    amsSocketPort: port,
    amsVersion: '1.0.0',

    // PES Configuration
    pesEndpoint: therigyEndpoint,
    pesPort: port,
    pesVersion: '1.0.0',

    // RMS Configuration
    rmsEndpoint: therigyEndpoint,
    rmsPort: port,
    rmsVersion: '1.0.0',

    // SLS Configuration
    slsEndpoint: therigyEndpoint,
    slsStage: 'sls-',
    slsVersion: '1.0.0',

    // TAS Configuration
    tasEndpoint: therigyEndpoint,
    tasPort: port,
    tasVersion: '1.0.0',

    // TRS configuration
    trsVersion: '1.0.0',
    trsEndpoint: therigyEndpoint,
    trsPort: port,
    ssoEndpoints: {
        'biologicsuat-stm': `${therigyEndpoint}/tas/1.0.0/saml2/biologics`,
        costco: `${therigyEndpoint}/tas/1.0.0/saml2/costco`,
        danafarber: `${therigyEndpoint}/tas/1.0.0/saml2/danafarber`,
        trinity: `${therigyEndpoint}/tas/1.0.0/saml2/trinity`,
    },
    // WALKME Configuration
    walkmeUrl: getWalkmeUrl(window.location.hostname),

    // Email Regex compliant with RFC-5322
    emailRegex:
        '^(([^<>()[]\\.,;:s@]+(.[^<>()[]\\.,;:s@]+)*)|(.+))@(([[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}])|(([a-zA-Z-0-9]+.)+[a-zA-Z]{2,}))$',
});

module.exports = env;
